import { Button, Paper, Typography } from "@mui/material";
import { Flex } from "~/components/Flex";
import { pluralize } from "~/lib/pluralize";

interface GithubSecurityPipelineAssignSpacesProps {
  onChangePairing: () => void;
  pairedSpaces: Array<string>;
}

export const GithubSecurityPipelineAssignSpaces = ({
  onChangePairing,
  pairedSpaces,
}: GithubSecurityPipelineAssignSpacesProps) => {
  const hasPairedSpaces = pairedSpaces.length > 0;
  const pairedSpacesCount = pairedSpaces.length;

  return (
    <Flex flexDirection="column" gap={2}>
      <Paper
        sx={{
          p: 2,
          borderRadius: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {hasPairedSpaces ? (
          <Flex flexDirection="column" gap={1}>
            <Typography>
              {pairedSpacesCount} {pluralize("space", pairedSpacesCount)}{" "}
              {pairedSpacesCount > 1 ? "are" : "is"} paired and protected.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {pairedSpaces.map((space) => space).join(", ")}
            </Typography>
          </Flex>
        ) : (
          <Typography>Add a new space repo pairing to get started</Typography>
        )}
        <Button variant="contained" color="primary" onClick={onChangePairing}>
          Edit pairings
        </Button>
      </Paper>
    </Flex>
  );
};
